export const NAV = 'NAV';
export const GROSS_NOTIONALS = 'Gross Notional';
export const FUND_VAR = 'Fund VaR (1M, 99%)';
export const RELATIVE_VAR = 'Relative VaR (1M, 99%)';
export const CHART_PADDINGS = 40;
export const TABS = [RELATIVE_VAR, FUND_VAR, NAV, GROSS_NOTIONALS];
export const DATE_FORMAT = 'dd-MMM-yyyy';
export const PAGE_BG_COLOR = '#1f2329';
export const PLOT_LINE_COLOR = '#FD4444';
export const WHITE_COLOR = '#FFFFFF';
export const CHART_TOOLTIP_TEXT_COLOR = '#1F2329';
export const DEFAULT_MAX_CHART_VALUE = 250;
export const LIMIT_CORRECTION_MULTIPLIER = 1.25;
export const AXIS_MASTER_LABEL_DATE_FORMAT = 'yyyy';
export const AXIS_LABEL_DATE_FORMAT = 'MMM-yyyy';
export const AXIS_LABEL_DATE_FORMAT_LONG = 'dd-MMM-yyyy';
export const GRID_LINE_COLOR = '#41454A';
export const LABEL_OPACITY = 0.7;

export const TITLE_TEXT = 'Value(USD)';

export const REL_PV = 'RelPV';
export const REL_NAV = 'RelNAV';
export const ABSOLUTE = 'Abs';
